"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/components/Conversation/Message/FileMessage/PlayGlyph.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);






const PlayGlyph = ({ size = 13, className }) => (
  _react2.default.createElement('svg', {
    className: className,
    width: size,
    height: size,
    viewBox: "0 0 12 14"   ,
    fill: "none",
    'aria-hidden': "true",
    focusable: "false", __self: this, __source: {fileName: _jsxFileName, lineNumber: 9}}

    , _react2.default.createElement('path', {
      d: "M11.1 6.13 1.9.42A1 1 0 0 0 .4 1.28v11.44a1 1 0 0 0 1.5.86l9.2-5.71a1 1 0 0 0 0-1.74Z"                  ,
      fill: "currentColor", __self: this, __source: {fileName: _jsxFileName, lineNumber: 18}}
    )
  )
)

exports. default = PlayGlyph
